import { SelectMui } from 'src/components/SelectMui'
import TextFieldMui from 'src/components/TextFieldMui'
import styled from 'styled-components'

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  gap: 1.2rem !important;
`

export const CustomTextField = styled(TextFieldMui)`
  margin: 0 !important;
`

export const CustomSelect = styled(SelectMui)`
  margin: 0 !important;
`
